/**
 * ITime includes a time value in UTC along with an (optional) timezone where
 * the event originated to support conversion back to local time.
 */
export interface ITime {
  /**
   * The original time before conversion to UTC (if any)
   */
  raw?: string;
  /**
   * Timezone from the IANA tz database.
   * https://www.iana.org/time-zones
   */
  timezone?: string;
  /**
   * Universal Coordinated Time (UTC) value.
   */
  utc: string;
}

/**
 * ISO8601 week days.
 *
 * ISO8601 specifies that weeks start with Monday, with Monday and Sunday
 * represented as 1 and 7 respectively.
 *
 * https://en.wikipedia.org/wiki/ISO_week_date
 */
export enum IsoWeekday {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 7,
}
